var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrevious(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_790_10898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6416 12.3379C5.52383 12.314 5.415 12.2552 5.3291 12.168L1.24512 8.02051L1.16992 7.92676C1.1478 7.89322 1.12859 7.85772 1.11328 7.82031L1.07812 7.7041C1.07034 7.66445 1.06641 7.62362 1.06641 7.58301C1.06643 7.54261 1.0704 7.50234 1.07812 7.46289L1.11328 7.34668C1.12858 7.30926 1.14781 7.27379 1.16992 7.24024L1.24512 7.14649L5.3291 2.99902C5.44357 2.88275 5.59915 2.81641 5.76172 2.81641C5.88338 2.81647 6.00107 2.85361 6.10059 2.9209L6.19434 2.99902C6.30847 3.11515 6.37201 3.27211 6.37207 3.43555C6.37207 3.59919 6.30869 3.75684 6.19434 3.87305L3.14844 6.96484L13.2031 6.96484C13.3248 6.96493 13.4425 7.00194 13.542 7.06934L13.6348 7.14648C13.749 7.2625 13.8134 7.4196 13.8135 7.58301C13.8135 7.74653 13.7491 7.90441 13.6348 8.02051L13.542 8.09766C13.4425 8.16499 13.3248 8.20207 13.2031 8.20215L3.14941 8.20215L6.19434 11.2939C6.30849 11.41 6.37196 11.5671 6.37207 11.7305C6.37207 11.8941 6.30862 12.0518 6.19434 12.168L6.10059 12.2451C6.00101 12.3125 5.88351 12.3496 5.76172 12.3496L5.6416 12.3379Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_790_10898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(14 14) rotate(180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevious);
export default __webpack_public_path__ + "static/media/iconPrevious.96f4f707880d44e594a28ee116504c7f.svg";
export { ForwardRef as ReactComponent };